export const ArrowLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_259)">
        <path
          d="M9.00098 17L14.001 12L9.00098 7L10.0008 6L16.0008 12L10.0008 18L9.00098 17Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_259">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.00244141 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
